(function () {
  var productos = [
    'Florálís | Sandalias Florales con talón descubierto',
    'Sandalias de encaje floral',
    'Encaje | Zapatillas con encaje floral',
    'Celeste | Botines de Encaje con Tacones',
    'Vittoria | Elegantes sandalias trenzadas',
    'Carla | Vestido maxi elegante y sencillo',
    'Elsa | Conjunto Elegante Hombros Descubiertos',
    'Vestido Almudena™ | Elegancia Sofisticada',
    'Theo™ | Gorra plana de denim premium',
    'Gafas de sol polarizadas',
    'EMIDIO | Gafas de sol ahumadas',
    'MAGNO | Gafas de sol gris ahumado',
    'MARCO | Gafas de sol negras',
    'PANTERA | Gafas elegantes',
    'ALESIO | Gafas de sol azul cielo',
    'ELÍAS | Conjunto dos piezas de verano',
    'DIONISIO | Conjunto dos piezas chillout',
    'SANTOS | Conjunto de dos piezas',
    'Leblanc™ | Pantalón de pana para hombre',
    'ERMES | Pantalones cortos de verano',
    'LUCAS | Traje de lino premium',
    'Ryan™ | Sudadera Utilitaria para Exteriores',
    'Charles™ | Sudadera con media cremallera',
    'Diego™ | Sudadera con capucha resistente',
    'SILVORO | Chaleco elegante',
    'LAURENT MONACO | Polo de manga larga',
    'Ivan™ | Chaqueta acolchada corte moderno',
    'Udo | Chaqueta de cordero con forro polar',
    'Dieter | Blazer de punto estructurado',
    'Roveri | Chaqueta de pana',
    'Leon – Chaqueta de punto elegante',
    'Salomon™ | Chaqueta de ante',
    'Lorenzo™ | Chaqueta sastre',
    'Bram™ | Chaqueta acolchada premium',
    'Cagliari | Jersey de cuello alto de lana merino',
    'Marcus | Abrigo de invierno',
    'Samuel™ | Pantalones anchos con cintura ajustable',
    'Elio™ | Chaqueta clásica de aviador',
    'Anillo con incrustaciones de perlas',
    'Pulsera Aventura de la Perla del Mar',
    'Anillo de Oro Gota Real',
    'Collar verde Joana Grøn con esmeralda',
    'Pulsera vintage con perlas y gemas verdes doradas',
    'Pulsera clásica abierta con onda dorada'
  ];

  var nombres = [
    'María G.', 'Carmen L.', 'Ana M.', 'Lucía F.', 'Isabel R.',
    'Elena S.', 'Marta P.', 'Laura D.', 'Rosa T.', 'Patricia N.',
    'Carlos B.', 'Antonio V.', 'Manuel J.', 'José R.', 'Francisco M.',
    'David H.', 'Javier C.', 'Miguel A.', 'Alejandro O.', 'Sergio I.',
    'Sofía E.', 'Cristina U.', 'Paula Y.', 'Andrea Q.', 'Nuria W.',
    'Roberto Z.', 'Fernando X.', 'Raúl K.', 'Álvaro Ll.', 'Diego Ñ.'
  ];

  var ciudades = [
    'Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Bilbao',
    'Zaragoza', 'Málaga', 'Murcia', 'Palma', 'Las Palmas',
    'Alicante', 'Córdoba', 'Valladolid', 'Vigo', 'Gijón',
    'Granada', 'Santander', 'Pamplona', 'Vitoria', 'Burgos',
    'Almería', 'Salamanca', 'Huelva', 'Badajoz', 'Cádiz',
    'Tarragona', 'Lleida', 'Logroño', 'Toledo', 'Cáceres'
  ];

  var tiempos = [
    'hace 3 min', 'hace 8 min', 'hace 12 min', 'hace 20 min',
    'hace 35 min', 'hace 1 hora', 'hace 2 horas'
  ];

  function rand(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function crearToast() {
    var ciudad = rand(ciudades);
    var nombre = rand(nombres);
    var producto = rand(productos);
    var tiempo = rand(tiempos);

    var toast = document.createElement('div');
    toast.className = 'vr-toast';
    toast.innerHTML =
      '<div class="vr-toast__icon">🛍️</div>' +
      '<div class="vr-toast__body">' +
        '<span class="vr-toast__name">' + nombre + ' (' + ciudad + ') compró</span>' +
        '<span class="vr-toast__product">' + producto + '</span>' +
        '<span class="vr-toast__time">' + tiempo + '</span>' +
      '</div>' +
      '<button class="vr-toast__close" aria-label="Cerrar">✕</button>';

    document.body.appendChild(toast);

    toast.querySelector('.vr-toast__close').addEventListener('click', function () {
      ocultarToast(toast);
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('vr-toast--visible');
      });
    });

    var timer = setTimeout(function () {
      ocultarToast(toast);
    }, 6000);

    toast._timer = timer;
  }

  function ocultarToast(toast) {
    clearTimeout(toast._timer);
    toast.classList.remove('vr-toast--visible');
    toast.addEventListener('transitionend', function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, { once: true });
  }

  setTimeout(function () {
    crearToast();
    setInterval(crearToast, 120000);
  }, 5000);

})();